import DatePicker from "legacy/DatePicker"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class PricingExceptions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      startDate: null,
      endDate: null,
      rate: null,
    }
    this.validator = validatorFactory()
    this.saveException = this.saveException.bind(this)
    this.renderDate = this.renderDate.bind(this)
    this.exceptionsTable = this.exceptionsTable.bind(this)
  }

  saveException() {
    if (this.validator.allValid()) {
      this.props.createException(
        this.state.startDate,
        this.state.endDate,
        this.state.rate
      )
      this.setState({ startDate: null, endDate: null, rate: null })
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  renderDate(title, setValue, value, startDate) {
    return (
      <div className="col-sm-3">
        <div className="form-group bs-mb-0">
          <label>{title}</label>
          <div className="form-control-with-icon">
            <i className="fa-kit fa-calendar form-control-icon-left" />
            <DatePicker
              setParentState={setValue}
              value={value}
              datesDisabled={[]}
              clearBtn={true}
              startDate={startDate}
            />
          </div>
          {this.validator.message(title, value, "required")}
        </div>
      </div>
    )
  }

  exceptionsTable() {
    if (this.props.exceptions.length > 0) {
      return (
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Rate</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {this.props.exceptions.map((e, i) => {
              if (!e._destroy) {
                return (
                  <tr key={i}>
                    <td>
                      {e.startDate} - {e.endDate}
                    </td>
                    <td>${e.rate}</td>
                    <td>
                      <span
                        className="btn-ghost"
                        onClick={() => this.props.removeExceptionByIndex(i)}
                      >
                        remove
                      </span>
                    </td>
                  </tr>
                )
              }
              return null
            })}
          </tbody>
        </table>
      )
    }
    return null
  }

  render() {
    return (
      <div>
        {this.exceptionsTable()}
        <hr />
        <div className="row nested-row" style={{ marginTop: 15 }}>
          {this.renderDate(
            "Start Date",
            (startDate) => this.setState({ startDate }),
            this.state.startDate,
            null
          )}
          {this.renderDate(
            "End Date",
            (endDate) => this.setState({ endDate }),
            this.state.endDate,
            this.state.startDate
          )}
          <div className="col-sm-3">
            <div className="form-group">
              <label>Rate</label>
              <input
                type="text"
                className="form-control"
                value={this.state.rate}
                onChange={(e) => this.setState({ rate: e.target.value })}
              />
              {this.validator.message("rate", this.state.rate, "required")}
            </div>
          </div>
          <div className="col-sm-3">
            <button
              type="button"
              className="btn btn-secondary"
              style={{ marginTop: 24, width: "100%", padding: 10 }}
              onClick={this.saveException}
            >
              Add
            </button>
          </div>
        </div>
        <a
          className="btn-ghost float-left"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: -10 }}
          href="https://fullcalendar.io/js/fullcalendar-3.7.0/demos/gcal.html"
        >
          View US Holiday Calendar
        </a>
      </div>
    )
  }
}

PricingExceptions.propTypes = {
  exceptions: PropTypes.array.isRequired,
  createException: PropTypes.func.isRequired,
  removeExceptionByIndex: PropTypes.func.isRequired,
}

export default PricingExceptions
